import { useQuery } from "@apollo/client";
import { GET_COMMUNITY_TIPPERS } from "../../../queries/mutation/broadcaster/queries";
import { GET_TIP_QUEUE } from "../../../queries/tipQueue";
import { GET_TOTAL_TOKENS } from "../../../queries/user_queries";
import StatTile from "../broadcasters/community/StatTile";
import { tokensToDollars } from "../broadcasters/community/format";

// The numbers that matter at a glance, all real: tokens this month, how
// many tippers and fan club members there are, and what's owed.
const HomeStats = () => {
  const { data: tokens } = useQuery(GET_TOTAL_TOKENS);
  const { data: tippers } = useQuery(GET_COMMUNITY_TIPPERS, {
    variables: { limit: 1 },
  });
  // The banked-tips panel beside this polls the same query; this reads
  // what it keeps fresh.
  const { data: queue } = useQuery(GET_TIP_QUEUE);

  const monthTokens: number | undefined = tokens?.getTotalTokens;
  const page = tippers?.getCommunityTippers;
  const banked: number | undefined = queue?.getTipQueue?.banked?.length;
  const value = (n: number | undefined) => (n === undefined ? "…" : n);

  return (
    <div className="grid grid-cols-2 lg:grid-cols-4 gap-2">
      <StatTile
        label="Tokens this month"
        value={value(monthTokens)}
        hint={monthTokens !== undefined ? tokensToDollars(monthTokens) : undefined}
        className="text-primary"
      />
      <StatTile
        label="Fan club"
        value={value(page?.inFanclubCount)}
        hint={page ? `of ${page.totalTippers.toLocaleString()} tippers` : undefined}
        className="text-success"
      />
      <StatTile
        label="On Reinstorm"
        value={value(page?.linkedCount)}
        hint="with an account"
        className="text-info"
      />
      <StatTile
        label="Banked tips"
        value={value(banked)}
        hint="owed between shows"
        className="text-accent"
      />
    </div>
  );
};

export default HomeStats;
